import { render, staticRenderFns } from "./HideForGroupForm.vue?vue&type=template&id=487ce60e"
import script from "./HideForGroupForm.vue?vue&type=script&lang=js"
export * from "./HideForGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports